// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"calendar"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 10H3V21H21V10Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 10H3V5H21V10Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 10H21M3 10V5H21V10M3 10V21H21V10M7 5V1.5M17 5V1.5","strokeWidth":"props.strokeWidth"}}]}]};

const CalendarIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'calendar',
    ref,
    icon: element,
  },
));

CalendarIcon.displayName = 'CalendarIcon';

export default CalendarIcon;
